import { PURCHASE_SECTION } from '../../classnames/home';
import PurchaseSectionAnalytics from './analytics';

export default class PurchaseSection {
  constructor() {
    this.container = document.getElementById(PURCHASE_SECTION);
    this.PurchaseSectionAnalytics = new PurchaseSectionAnalytics(this.container);
  }

  initializeEventListeners = () => {
    if (!this.container) { return; }

    // TODO - move to separate module and make it universal (if there is a section id
    // in query string - move to that section if it exists on the page. Else - ignore)
    if (window.location.hash === '#purchase-section') {
      const purchaseSection = document.getElementById('purchase-section');

      if (purchaseSection) {
        setTimeout(() => {
          purchaseSection.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      }
    }

    this.PurchaseSectionAnalytics.initializeEventListeners();
  };
}
